import React, { useState, useMemo } from "react";
import ClassNames from "classnames";
import { navigate } from "gatsby";
import SEO from "../../../../components/seo";
import Layout from "../../../../components/Layout";
import Section from "../../../../components/Section";
import Container from "../../../../components/Container";
import * as s from "../../../../partials/News/news-v2.module.scss";
// JSReveal
import JSReveal from "../../../../components/JSReveal";
import H, { HeadingType, WeightType } from "../../../../components/Heading";
import Button from "../../../../components/Button";
import MultiItemBlock from "../../../../components/MultiItemBlock";
import MultiItemBlockItem from "../../../../components/MultiItemBlockItem";
import CTABlock from "../../../../components/CTABlock";

import Desktop from "../../../../components/Icons/_LineStyle/Desktop";
import Shop from "../../../../components/Icons/_LineStyle/Shop";
import Plane from "../../../../components/Icons/_LineStyle/Plane";
import Circuit from "../../../../components/Icons/_LineStyle/Circuit";
import Car from "../../../../components/Icons/_LineStyle/Car";
import Game from "../../../../components/Icons/_LineStyle/Game";
import Coin from "../../../../components/Icons/_LineStyle/Coin";
import SocialMedia from "../../../../components/Icons/_LineStyle/SocialMedia";
import DivHtml from "../../../../components/DivHtml";
// Content Data
import {
  getLocalizedPath,
  getContentData,
  getStaticData,
} from "../../../../helperFunctions";
import { Content } from "../../../../partials/Industries/content";
import {
  getQueriedFluidImage,
  getBackgroundImageData,
} from "../../../../CMSImage";
import { ContentSEO } from "../../../../partials/Industries/CaseStudies";
import industriesStaticContent from "../../../../../content/industries.json";
import NewsItemCard from "../../../../components/NewsItemCard";
import Select from "../../../../components/Select";

const PageIndustriesCaseStudies = ({
  pageContext: { locale, alias, htmlLang },
  location,
}) => {
  const pageSEO = useMemo(() => getContentData(ContentSEO, "seo", locale));

  const cardNames = [
    "INDUSTRIES-FEATURED_ITEM_CARD_8",
    "INDUSTRIES-FEATURED_ITEM_CARD_10",
    "INDUSTRIES-FEATURED_ITEM_CARD_11",
    "INDUSTRIES-FEATURED_ITEM_CARD_12",
    "INDUSTRIES-FEATURED_ITEM_CARD_9",
    "INDUSTRIES-FEATURED_ITEM_CARD_1",
    "INDUSTRIES-FEATURED_ITEM_CARD_2",
    "INDUSTRIES-FEATURED_ITEM_CARD_3",
    "INDUSTRIES-FEATURED_ITEM_CARD_4",
    "INDUSTRIES-FEATURED_ITEM_CARD_5",
    "INDUSTRIES-FEATURED_ITEM_CARD_6",
    "INDUSTRIES-FEATURED_ITEM_CARD_7",
  ];

  const cardContent = {};
  const cardContent2 = {};

  // get content data for both global and current locale.
  cardNames.forEach((cardName) => {
    if (locale !== "global") {
      cardContent[`${cardName}__global`] = getContentData(
        Content,
        "featured_item_card",
        "global",
        cardName
      );
    }
    cardContent[`${cardName}__${locale}`] = getContentData(
      Content,
      "featured_item_card",
      locale,
      cardName
    );
  });

  var globalData2;
  cardNames.forEach((cardName) => {
    globalData2 = getContentData(
      Content,
      "featured_item_card",
      "global",
      cardName
    );
    cardContent2[`${cardName}`] = globalData2;
  });

  // helper function to easily get locale-sensitive card content
  const getCardContent = (index) => {
    return cardContent[`${cardNames[index]}__${locale}`];
  };
  const block_title = useMemo(() => getContentData(Content, "multi_item_block_title", locale));
  const block_item = useMemo(() => getContentData(Content, "multi_item_block_items", locale));
  const cta_block = useMemo(() => getContentData(Content, "cta_block", locale));
  const itemMapping = [
    { icon: <Desktop />, title: block_item[0].title },
    { icon: <Shop />, title: block_item[1].title },
    { icon: <SocialMedia />, title: block_item[2].title },
    { icon: <Circuit />, title: block_item[3].title },
    { icon: <Plane />, title: block_item[4].title },
    { icon: <Car />, title: block_item[5].title },
    { icon: <Game />, title: block_item[6].title },
    { icon: <Coin />, title: block_item[7].title },
  ];
  const [selectedCategory, setSelectedCategory] = useState(
    industriesStaticContent.category[1]
  );

  return (
    <Layout
      locale={locale}
      alias={alias}
      htmlLang={htmlLang}
      location={location}
    >
      <SEO
        lang="en"
        title={pageSEO.title}
        description={pageSEO.description.data?.description}
        keywords={pageSEO.keywords.data?.keywords}
        location={location}
      //sending undefined as tdcx logo image need to show on directory page
      //image={xyz?.image?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src}
      />
      <Section
        className={ClassNames("xs_pt_3", "xs_pb_3", "lg_pb_6", "lg_pt_6")}
      >
        <Container indent>
          <JSReveal style={{ position: "relative", zIndex: 1 }}>
            <div className={s.insideHeading}>
              <H
                type={HeadingType.H1}
                size="h2"
                weight={WeightType.BOLD}
                color="rvGrey500"
              >
                {getStaticData(industriesStaticContent.caseStudies, locale)}
              </H>
              <Select
                selectedOption={{
                  label: selectedCategory.label,
                  value:
                    typeof selectedCategory.value === "object"
                      ? getStaticData(selectedCategory.value, locale)
                      : selectedCategory.value,
                }} // Press Release
                selectedHolderStyle={{ minWidth: "228px" }}
                selectContainerStyle={{ marginRight: "0px" }}
                optionContainerStyle={{
                  minHeight: "auto",
                  height: "210px",
                }}
                options={[
                  ...industriesStaticContent.category.map((s) => {
                    let trimD = getStaticData(s.value, locale);
                    if (trimD === "Featured Articles") {
                      trimD = "Feature Articles";
                    }
                    return {
                      value: trimD,
                      label: s.label,
                      link: s.link,
                    };
                  }),
                ]}
                onOptionClick={({ ...props }) => {
                  const { selected } = props;
                  navigate(getLocalizedPath(locale, alias, selected.link));
                }}
              />
            </div>
            <div className={s.subHead}>
              <H
                type={HeadingType.H4}
                size="h4"
                weight={WeightType.SEMIBOLD}
                color="rvGrey500"
              >
                {getStaticData(industriesStaticContent.descCaseStudies, locale)}
              </H>
            </div>
          </JSReveal>
          <div className={ClassNames("featuredItemList", "xs_pt_1", "md_pt_2")}>
            {cardNames.map((item, index) => {
              return (
                <NewsItemCard
                  key={index}
                  gatsbyImageUrl={getQueriedFluidImage(
                    getBackgroundImageData(
                      cardContent2,
                      cardContent,
                      item,
                      locale
                    )
                  )}
                  imageAlt={getCardContent(index).title}
                  publishedDate=""
                  title={getCardContent(index).title}
                  category=""
                  to={`${getLocalizedPath(
                    locale,
                    alias,
                    getCardContent(index).button_link
                  )}`}
                  hideCategory={true}
                  hideNewsPaper={true}
                  newspaperName={undefined}
                  articleOrigin=""
                  labels={getCardContent(index).label?.split("|")}
                />
              );
            })}
          </div>
        </Container>
      </Section>

      <Section
        className={ClassNames("xs_pt_1", "xs_pb_2", "md_pt_2", "lg_pb_4")}
      >
        <Container>
          <MultiItemBlock
            title={
              <H
                type={HeadingType.H2}
                size="h2"
                weight={WeightType.SEMIBOLD}
                color="rvGrey500"
              >
                {block_title.title}
              </H>
            }
            variant="industries"
          >
            {itemMapping.map((x, i) => {
              return (
                <JSReveal key={i}>
                  <MultiItemBlockItem
                    icon={x.icon}
                    title={x.title}
                    titleSize="small"
                  />
                </JSReveal>
              );
            })}
          </MultiItemBlock>
        </Container>
      </Section>

      <Section
        variant="sectionBgGrey"
        className={ClassNames("xs_pt_5", "xs_pb_5")}
      >
        <Container indent>
          <JSReveal>
            <CTABlock
              title={
                <H
                  type={HeadingType.H2}
                  size="h2"
                  weight={WeightType.SEMIBOLD}
                  color="rvGrey500"
                >
                  {cta_block.title}
                </H>
              }
              description={<DivHtml>{cta_block.content.data.content}</DivHtml>}
              button={
                <Button
                  variant="primary"
                  size="large"
                  link={cta_block.button_link}
                >
                  {cta_block.button_text}
                </Button>
              }
            />
          </JSReveal>
        </Container>
      </Section>
    </Layout>
  );
};

export default PageIndustriesCaseStudies;
